module.exports = {
  schema: {
    name: '品牌資料',
    type: 'Object',
    contents: {
      ragicId: {
        type: 'Number',
        ragicId: '_ragicId',
        name: 'RagicId',
        disabled: true,
      },
      key: {
        type: 'String',
        name: '品牌編號',
        ragicId: '1000128',
      },
      name: {
        type: 'String',
        ragicId: '1000129',
        name: '品牌名稱',
      },
      brandCode: {
        type: 'String',
        ragicId: '1000130',
        name: '品牌簡碼',
        // ragicParser: 'firstNode',
        // disabled: true,
        // formatter: (staffer) => (!isNil(staffer) ? [staffer.key, staffer.name].join('-') : ''),
      },
      shortName: {
        type: 'String',
        ragicId: '1000131',
        name: '品牌簡稱',
      },
      type: {
        type: 'Array',
        ragicId: '1000103',
        name: '商品類別',
        input: 'select',
        // multi: true,
        contents: [{
          options: ['A', 'B', 'C', 'D', 'E', 'F'],
          type: 'String',
          name: 'options-element',
        }],
      },
      supplierRef: {
        ragicId: '1000001',
        name: '供應商',
        type: 'ObjectId',
        reference: 'suppliers',
        refKeys: ['name'],
        input: 'select',
        ragicParser: 'firstNode',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
        type: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 130 },
        { key: 'brandCode', width: 100 },
        { key: 'shortName', width: 100 },
        { key: 'type', width: 100 },
        { key: 'supplierRef', width: 100 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '品牌資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'brandCode' }],
            [{ key: 'shortName' }],
            [{ key: 'type' }],
            [{ key: 'supplierRef' }],
            [{ key: 'ragicCenterNodeId' }],
            [{ key: 'ragicStoreNodeId' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/brands.js